'use strict';

import VZTcBaseCard from './VZTcBaseCard';

/**
 * @class VZTcRestOfWorld
 * @extends VZTcBaseCard
 * @description Handles the Teams Calling rest of world card with slider functionality
 */
export default class VZTcRestOfWorld extends VZTcBaseCard {}

if (!window.customElements.get('vz-tc-rest-of-world')) {
    window.customElements.define('vz-tc-rest-of-world', VZTcRestOfWorld);
}
